import React from 'react';

import { IBodyCopyFields } from '@/types/contentful';

import RichText from '../RichText';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { getImageDataWithHttps } from '~/utils/contentful';
import Image from 'next/image';

type BodyCopyProps = IBodyCopyFields;

const RICH_TEXT_OVERRIDES: RenderNode = {
  [BLOCKS.EMBEDDED_ASSET]: (node) => (
    <Image {...getImageDataWithHttps(node.data.target)} />
  )
};

export function BodyCopy({ sectionId, copy }: BodyCopyProps) {
  return (
    <div
      id={sectionId}
      className="mb-8 mt-8 flex w-full scroll-mt-24 justify-center tablet:mb-12 tablet:mt-12"
      data-blockid="bodyCopy"
      data-testid="bodyCopy"
    >
      <div className="w-full max-w-7xl px-4 tablet:px-16">
        <div className="flex justify-center">
          <div className="flex w-11/12 flex-col tablet:w-2/3">
            <RichText data={copy} overrideOptions={RICH_TEXT_OVERRIDES} />
          </div>
        </div>
      </div>
    </div>
  );
}
